import axios from 'axios'
import axiosRetry from 'axios-retry'
import router from './router'
import { mutations } from './store'

// https://github.com/softonic/axios-retry/issues/87
const retryDelay = (retryNumber = 0) => {
  const seconds = Math.pow(2, retryNumber) * 1000
  const randomMs = 1000 * Math.random()
  return seconds + randomMs
}

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {'X-Requested-With': 'XMLHttpRequest'},
  withCredentials: true
})


// Add a response interceptor for authentication failures
client.interceptors.response.use(function (response) {
  console.log("Intercepted - Response:")
  console.log(response);
  return response;
}, function (error) {
  console.log("Intercepted:" + error)
  if (error.response !== undefined && (error.response.status === 401 || error.response.status === 403)) {
    if (router.currentRoute.name !== "SignIn") {
      mutations.signOut()
      router.push({ name: 'SignIn' })
    }
  }
  return Promise.reject(error)
})

axiosRetry(client, {
  retries: 2,
  retryDelay,
  // retry on Network Error & 5xx responses
  retryCondition: axiosRetry.isRetryableError
})

export default client
